import { createContext } from 'react';

import { useVisibilityOptions } from 'hooks';
import { LocalStorageKey } from 'api/localStorage/constants';
import { DEFAULT_DETAILS_FIELD_VISIBILITY } from 'constants/details';

import { IVisibilityOptionsContext } from './models';

export const DetailViewContext = createContext<IVisibilityOptionsContext>({});

interface IProps {
  children: React.ReactNode;
}

export const DetailViewProvider = ({ children }: IProps) => {
  const { visibleFields, handleVisibleFieldsChange } = useVisibilityOptions(
    LocalStorageKey.ITEM_DETAIL_FIELDS,
    DEFAULT_DETAILS_FIELD_VISIBILITY
  );
  return (
    <DetailViewContext.Provider
      value={{ visibleFields, handleVisibleFieldsChange }}
    >
      {children}
    </DetailViewContext.Provider>
  );
};
